// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empleo-formacion .cabecera{ margin-bottom: 20px; margin-top: 20px;}
.empleo-formacion .col-izq{ width: 320px; }
.empleo-formacion .col-dcha{ width: calc(100% - 400px); }
.empleo-formacion .col-izq, .empleo-formacion .col-dcha{margin-top: 0px;}

.titulo-user select{
  font-size: 22px;
  line-height: 1.1;
  gap: 10px;
  font-weight: bold;
  border: none;
  border-bottom: 2px solid black;
  outline: none;
}


/* -----------------------------------------------------------------------------
// COLUMNA DERECHA - RECURSOS DESTACADOS
// ----------------------------------------------------------------------------- */
.empleo-formacion.tecnicos .titulo-user svg { font-size: 26px; }
.carrusel::-webkit-scrollbar { display: none; }/* Oculta la barra de desplazamiento en Chrome/Safari */

.carrusel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  color: #007932;
  border: none;
  font-size: 28px;
}

.carrusel-btn:hover {
  color: #000;
  font-size: 32px;
  background-color: #fff;
}


.izquierda { left: 0px; }
.derecha { right: 0px; }

.carrusel{ 
  flex-wrap: wrap;
  gap: 2.6%;
}

.carrusel-tecnicos{
  width: calc(100% - 70px);
  margin: 0 auto;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 10px 0;
  scrollbar-width: none;
  flex-wrap: nowrap;
}


.carrusel-social .carrusel{ flex-wrap: nowrap; }
.informacion-social .carrusel-social{ padding: 0px 30px; }


.carrusel .recurso{ 
  border: 1px solid #007932;
  border-left: 10px solid #007932; 
  border-radius: 12px;
  margin: 16px 0 12px 0;
  padding: 16px 20px 10px 15px;
  width: 23%;
  gap: 18px; 
}

.carrusel .recurso.azul{ 
  border: 1px solid #3C4A99;
  border-left: 10px solid #3C4A99; 
}

.carrusel .recurso.rosa{ 
  border: 1px solid #cc024f;
  border-left: 10px solid #cc024f; 
}

.carrusel .recurso.naranja{ 
  border: 1px solid #d24315;
  border-left: 10px solid #d24315; 
}

.carrusel-tecnicos .recurso{ 
  width: 35%; /* Más del 33% para que el tercero quede cortado */
  min-width: 35%;
  margin: 2.5px 0px;
}


.carrusel .recurso.formacion{ 
  border: 1px solid #b90248;
  border-left: 10px solid #b90248; 
}

.carrusel-social .recurso{ 
  border: 1px solid #3C4A99;
  border-left: 10px solid #3C4A99; 
}

.carrusel-social .carrusel-tecnicos .recurso{ 
  border: 1px solid #007932;
  border-left: 10px solid #007932; 
}

.carrusel-social .carrusel .recurso{ min-width: 300px; }

.carrusel .recurso svg{ 
  width: 20px; 
  height: 20px; 
}

.carrusel .recurso h2,
.carrusel .recurso p{ 
  line-height: 1.2;
  margin-bottom: 5px;
}

.carrusel .recurso .fecha{ margin-top: 20px; }
.carrusel .recurso .ubicacion{ margin-bottom: 15px; }


.carrusel .recurso .fecha-publicacion{ 
  text-align: right;
  margin-bottom: 20px;
}


.modal-overlay {
  position: fixed;
  top: 30px;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.842);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  width: 50%;
  max-width: 500px;
  border-radius: 20px;
  overflow: hidden;
}

.modal-header {
  background: #007932;
  color: white;
  padding: 15px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1.1;
  margin-left: 15px;
}

.modal-header h2 svg{font-size: 28px;}

.modal-overlay .close-button {
  border-radius: 10px;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0px 10px;
}

.close-button:hover{
  background-color: white;
  color: #007932;
}


.modal-body {
  padding: 7.5px 25px 20px 25px;
  max-height: 400px; /* Altura máxima del modal antes de hacer scroll */
  overflow-y: auto;
}

.modal-body table {
  width: 100%;
  border-collapse: collapse;
}

.modal-body th, .modal-body td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.modal-body th {
  font-weight: bold;
}


.no-scroll {
  overflow: hidden;
}

/* Estilo del scroll */
.modal-body::-webkit-scrollbar { width: 8px; }

.modal-body::-webkit-scrollbar-thumb {
background-color: #c2c2c2;
border-radius: 4px;
}

.modal-body::-webkit-scrollbar-track { background: #f1f1f1; }


/* -----------------------------------------------------------------------------
// PÁGINA RECURSOS - DESPLEGABLE MAPA RECURSOS LOCALES
// ----------------------------------------------------------------------------- */
.main-user.empleo-formacion .desplegable{ width: 100%; }


/********************************Media Queries********************************/
@media (max-width: 1600px) {
 
.carrusel .recurso{ 

  width: calc(33.33% - 1.75%); /* Ajusta el ancho para que quepan 3 recursos por fila */
}

.titulo-user select {
    font-size: 18px;
}
}`, "",{"version":3,"sources":["webpack://./src/pages/user/css/Empleo.css"],"names":[],"mappings":"AAAA,6BAA6B,mBAAmB,EAAE,gBAAgB,CAAC;AACnE,4BAA4B,YAAY,EAAE;AAC1C,6BAA6B,yBAAyB,EAAE;AACxD,wDAAwD,eAAe,CAAC;;AAExE;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;AACf;;;AAGA;;kFAEkF;AAClF,8CAA8C,eAAe,EAAE;AAC/D,+BAA+B,aAAa,EAAE,CAAC,uDAAuD;;AAEtG;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;;AAGA,aAAa,SAAS,EAAE;AACxB,WAAW,UAAU,EAAE;;AAEvB;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;;AAGA,4BAA4B,iBAAiB,EAAE;AAC/C,sCAAsC,iBAAiB,EAAE;;;AAGzD;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,UAAU,EAAE,kDAAkD;EAC9D,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,qCAAqC,gBAAgB,EAAE;;AAEvD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B,gBAAgB,EAAE;AAC7C,+BAA+B,mBAAmB,EAAE;;;AAGpD;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB,eAAe,CAAC;;AAErC;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;;AAGA;EACE,6BAA6B;EAC7B,iBAAiB,EAAE,kDAAkD;EACrE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB,iCAAiC,UAAU,EAAE;;AAE7C;AACA,yBAAyB;AACzB,kBAAkB;AAClB;;AAEA,uCAAuC,mBAAmB,EAAE;;;AAG5D;;kFAEkF;AAClF,0CAA0C,WAAW,EAAE;;;AAGvD,8EAA8E;AAC9E;;AAEA;;EAEE,2BAA2B,EAAE,wDAAwD;AACvF;;AAEA;IACI,eAAe;AACnB;AACA","sourcesContent":[".empleo-formacion .cabecera{ margin-bottom: 20px; margin-top: 20px;}\n.empleo-formacion .col-izq{ width: 320px; }\n.empleo-formacion .col-dcha{ width: calc(100% - 400px); }\n.empleo-formacion .col-izq, .empleo-formacion .col-dcha{margin-top: 0px;}\n\n.titulo-user select{\n  font-size: 22px;\n  line-height: 1.1;\n  gap: 10px;\n  font-weight: bold;\n  border: none;\n  border-bottom: 2px solid black;\n  outline: none;\n}\n\n\n/* -----------------------------------------------------------------------------\n// COLUMNA DERECHA - RECURSOS DESTACADOS\n// ----------------------------------------------------------------------------- */\n.empleo-formacion.tecnicos .titulo-user svg { font-size: 26px; }\n.carrusel::-webkit-scrollbar { display: none; }/* Oculta la barra de desplazamiento en Chrome/Safari */\n\n.carrusel-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: transparent;\n  color: #007932;\n  border: none;\n  font-size: 28px;\n}\n\n.carrusel-btn:hover {\n  color: #000;\n  font-size: 32px;\n  background-color: #fff;\n}\n\n\n.izquierda { left: 0px; }\n.derecha { right: 0px; }\n\n.carrusel{ \n  flex-wrap: wrap;\n  gap: 2.6%;\n}\n\n.carrusel-tecnicos{\n  width: calc(100% - 70px);\n  margin: 0 auto;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 10px 0;\n  scrollbar-width: none;\n  flex-wrap: nowrap;\n}\n\n\n.carrusel-social .carrusel{ flex-wrap: nowrap; }\n.informacion-social .carrusel-social{ padding: 0px 30px; }\n\n\n.carrusel .recurso{ \n  border: 1px solid #007932;\n  border-left: 10px solid #007932; \n  border-radius: 12px;\n  margin: 16px 0 12px 0;\n  padding: 16px 20px 10px 15px;\n  width: 23%;\n  gap: 18px; \n}\n\n.carrusel .recurso.azul{ \n  border: 1px solid #3C4A99;\n  border-left: 10px solid #3C4A99; \n}\n\n.carrusel .recurso.rosa{ \n  border: 1px solid #cc024f;\n  border-left: 10px solid #cc024f; \n}\n\n.carrusel .recurso.naranja{ \n  border: 1px solid #d24315;\n  border-left: 10px solid #d24315; \n}\n\n.carrusel-tecnicos .recurso{ \n  width: 35%; /* Más del 33% para que el tercero quede cortado */\n  min-width: 35%;\n  margin: 2.5px 0px;\n}\n\n\n.carrusel .recurso.formacion{ \n  border: 1px solid #b90248;\n  border-left: 10px solid #b90248; \n}\n\n.carrusel-social .recurso{ \n  border: 1px solid #3C4A99;\n  border-left: 10px solid #3C4A99; \n}\n\n.carrusel-social .carrusel-tecnicos .recurso{ \n  border: 1px solid #007932;\n  border-left: 10px solid #007932; \n}\n\n.carrusel-social .carrusel .recurso{ min-width: 300px; }\n\n.carrusel .recurso svg{ \n  width: 20px; \n  height: 20px; \n}\n\n.carrusel .recurso h2,\n.carrusel .recurso p{ \n  line-height: 1.2;\n  margin-bottom: 5px;\n}\n\n.carrusel .recurso .fecha{ margin-top: 20px; }\n.carrusel .recurso .ubicacion{ margin-bottom: 15px; }\n\n\n.carrusel .recurso .fecha-publicacion{ \n  text-align: right;\n  margin-bottom: 20px;\n}\n\n\n.modal-overlay {\n  position: fixed;\n  top: 30px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.842);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  width: 50%;\n  max-width: 500px;\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.modal-header {\n  background: #007932;\n  color: white;\n  padding: 15px 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h2 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  line-height: 1.1;\n  margin-left: 15px;\n}\n\n.modal-header h2 svg{font-size: 28px;}\n\n.modal-overlay .close-button {\n  border-radius: 10px;\n  border: none;\n  color: #fff;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0px 10px;\n}\n\n.close-button:hover{\n  background-color: white;\n  color: #007932;\n}\n\n\n.modal-body {\n  padding: 7.5px 25px 20px 25px;\n  max-height: 400px; /* Altura máxima del modal antes de hacer scroll */\n  overflow-y: auto;\n}\n\n.modal-body table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.modal-body th, .modal-body td {\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.modal-body th {\n  font-weight: bold;\n}\n\n\n.no-scroll {\n  overflow: hidden;\n}\n\n/* Estilo del scroll */\n.modal-body::-webkit-scrollbar { width: 8px; }\n\n.modal-body::-webkit-scrollbar-thumb {\nbackground-color: #c2c2c2;\nborder-radius: 4px;\n}\n\n.modal-body::-webkit-scrollbar-track { background: #f1f1f1; }\n\n\n/* -----------------------------------------------------------------------------\n// PÁGINA RECURSOS - DESPLEGABLE MAPA RECURSOS LOCALES\n// ----------------------------------------------------------------------------- */\n.main-user.empleo-formacion .desplegable{ width: 100%; }\n\n\n/********************************Media Queries********************************/\n@media (max-width: 1600px) {\n \n.carrusel .recurso{ \n\n  width: calc(33.33% - 1.75%); /* Ajusta el ancho para que quepan 3 recursos por fila */\n}\n\n.titulo-user select {\n    font-size: 18px;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
